import React from "react";
import "./NewsletterBanner.css";

const NewsletterBanner = () => {
  return (
    <section className="newsletter-section">
      {/* ==== TOP NEWSLETTER ==== */}
      <div className="newsletter-top">
        <div className="newsletter-container">
          <div className="newsletter-text">
            <h3>Join Newsletter</h3>
            <p>To receive our best deals</p>
          </div>
          <form className="newsletter-form">
            <input type="email" placeholder="Enter Your Email" />
            <button type="submit">SUBSCRIBE</button>
          </form>
        </div>
      </div>

      {/* ==== DISCOUNT SECTION ==== */}
      <div className="discount-section">
        <div className="discount-left">
          <img
            src="/assets/forest.jpg"
            alt="Discount Background"
            className="discount-bg"
          />
          <div className="discount-overlay">
            <h2>
              50% <span>discount</span>
            </h2>
          </div>
        </div>
        <div className="discount-right">
          <h3>Hit The Road</h3>
          <p>
            Book your dream adventure today and get up to{" "}
            <strong>50% OFF</strong> on selected tours. Explore breathtaking
            destinations, enjoy exclusive deals, and make memories that last
            forever. Hurry, this limited-time offer won’t last long!
          </p>
          <a href="/" className="see-more">
            SEE MORE
          </a>
        </div>
      </div>
    </section>
  );
};

export default NewsletterBanner;
